import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["allReviewsHref", "hideQualityRatings", "inline", "onUpdateFilters", "reviewStats", "reviewType"];
import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import OverallDistribution from './OverallDistribution';
import QualityDistribution from './QualityDistribution';
import Rating from './Rating';
import { RatingAxes } from '../constants/RatingAxes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColumnBlock = styled.div.withConfig({
  displayName: "ReviewsListStats__ColumnBlock",
  componentId: "sc-5mej9e-0"
})(["width:100%;padding-top:", ";padding-bottom:", ";padding-right:", ";border-bottom:1px solid ", ";"], ({
  isFirstBlock,
  theme
}) => isFirstBlock ? theme.space[0] : theme.space[500], ({
  theme
}) => theme.space[500], ({
  isFirstBlock,
  theme
}) => isFirstBlock ? theme.space[400] : theme.space[0], ({
  theme
}) => theme.color['border-core-subtle']);
const RowBlock = styled.div.withConfig({
  displayName: "ReviewsListStats__RowBlock",
  componentId: "sc-5mej9e-1"
})(["width:auto;padding-right:", ";"], ({
  isFirstBlock,
  theme
}) => isFirstBlock ? theme.space[400] : theme.space[0]);
export default function ReviewsListStats(_ref) {
  let {
      allReviewsHref,
      hideQualityRatings,
      inline = false,
      onUpdateFilters,
      reviewStats,
      reviewType
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const overallRatingAvg = reviewStats.getAxisAverage(RatingAxes.OVERALL);
  const totalReviews = reviewStats.get('count');
  const showQualityRatings = !hideQualityRatings && reviewStats.hasQualityRatings();
  const flexDirection = inline ? 'row' : 'column';
  const flexWidth = inline ? '100%' : 'auto';
  const Block = inline ? RowBlock : ColumnBlock;
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    flexDirection: flexDirection,
    justifyContent: "space-between",
    inlineSize: flexWidth
  }, rest, {
    children: [/*#__PURE__*/_jsxs(Block, {
      isFirstBlock: true,
      children: [inline && /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.averageRating"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-1000",
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          stripInsignificantZeros: false,
          value: overallRatingAvg,
          precision: 1
        })
      }), /*#__PURE__*/_jsx(Rating, {
        rating: overallRatingAvg,
        direction: "column",
        label: /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "detail-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.stats.reviewCount",
            options: {
              count: reviewStats.get('count')
            }
          })
        }),
        labelSize: "medium"
      }), allReviewsHref && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(Link, {
          href: allReviewsHref,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.stats.seeAllReviews"
          })
        })
      })]
    }), !showQualityRatings && /*#__PURE__*/_jsxs(Block, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.totalReviews"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-1000",
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          stripInsignificantZeros: false,
          value: totalReviews,
          precision: 0
        })
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.stats.reviewTotal",
          options: {
            count: reviewStats.get('count')
          }
        })
      })]
    }), /*#__PURE__*/_jsx(Block, {
      children: /*#__PURE__*/_jsx(OverallDistribution, {
        onUpdateFilters: onUpdateFilters,
        reviewStats: reviewStats
      })
    }), showQualityRatings && /*#__PURE__*/_jsx(Block, {
      children: /*#__PURE__*/_jsx(QualityDistribution, {
        heading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.qualityDistribution.heading"
        }),
        qualityRatings: reviewStats.getQualityRatings(),
        reviewType: reviewType,
        showLabelTooltips: true
      })
    })]
  }));
}